import router from './router'
import { setLocale } from './lang';
import store from './store';
import { getCanonicalPath, getRouteContentPath, getRouteEventId, getRouteLang, supportedLocales } from './utils/route';

router.beforeEach((to, from, next) => {
  const routeEventId = getRouteEventId(to);
  const routeLang = getRouteLang(to);

  if (to.query.event_id || to.query.lang) {
    const locale = supportedLocales.includes(to.query.lang) ? to.query.lang : routeLang;
    const eventId = to.query.event_id || routeEventId;
    const normalizedTo = {
      ...to,
      params: { ...to.params, lang: locale, event_id: eventId },
    };
    const query = { ...to.query };
    delete query.event_id;
    delete query.lang;
    next({
      path: getCanonicalPath(normalizedTo, getRouteContentPath(to)),
      query,
      replace: true,
    });
    return;
  }

  localStorage.setItem('event_id', JSON.stringify(routeEventId));
  store.commit('SET_EVENT_ID', Number(routeEventId));
  const locale = supportedLocales.includes(routeLang) ? routeLang : 'zh';
  sessionStorage.pcMicroSiteEditLang = locale;
  setLocale(locale);
  if (to.path.startsWith('/draft')) {
    sessionStorage.pcMicroStationMode = 'draft'
  } else {
    if (from.path.startsWith('/draft')) {
      const draftPath = getCanonicalPath({ ...to, path: '/draft' + to.path }, getRouteContentPath(to));
      sessionStorage.pcMicroStationMode = 'draft'
      next({ path: draftPath, query: to.query, params: to.params });
      return;
    } else {
      sessionStorage.pcMicroStationMode = 'formal'
    }
  }
  next();

})
